import $ from 'jquery';

class ParallaxBlock {
    constructor() {

        this.scrollHeight = document.body.scrollHeight;
        this.windowHeight = window.innerHeight;
        this.$parallax = $('.parallax-block');

        if ( this.$parallax ) {
            this.init();
        }

    }

    init() {

        window.addEventListener('scroll', () => {
            this.calcParallax();
        });

    }

    calcParallax() {
        
        let scrollTop = window.pageYOffset;
        let scrollPercentage = this.calcScrollPercentage(scrollTop);
        // let height = $(window).height();
        let speed = 0.5;

        this.$parallax.css('background-position-y', `${scrollPercentage * speed}%`);

        // let rect = this.$parallax[0].getBoundingClientRect();
        // let in_min = -(rect.height / 2);
        // let in_max = height + (rect.height / 2);
        // let out_min = -70;
        // let out_max = 70;

        // let val = rect.top + (rect.height/2)
        // let move = (val - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;

        //this.$parallax.find('.parallax-block--content').css('transform', `translateY(${move}%)`);

    }
    

    calcScrollPercentage( scrollPos ) {
        return scrollPos / (this.scrollHeight- this.windowHeight) * 100;
    }
}

export default ParallaxBlock;


// WEBPACK FOOTER //
// ./src/js/components/parallax.js